import { render } from "./XIconSolidTicketPercent.vue?vue&type=template&id=aaadabb0"
import script from "./XIconSolidTicketPercent.vue?vue&type=script&lang=js"
export * from "./XIconSolidTicketPercent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidTicketPercent.vue"]])

export default __exports__